import type { SettingsData } from '@/features/settings/types';
import { useGetCurrentUserSubscription } from '@/shared/hooks/queries/generated';

interface UseSettingsDataReturn {
  settings: SettingsData;
  loading: boolean;
  error: string | null;
}

export function useSettingsData(): UseSettingsDataReturn {
  const { data, isLoading } = useGetCurrentUserSubscription(
    {},
    {
      refetchInterval: 5000,
    },
  );

  const settings: SettingsData = {
    isPaymentTabAvailable: !!data?.getCurrentUserSubscription,
  };

  return {
    settings,
    loading: isLoading,
    error: 'Impossible de récupérer les paramètres',
  };
}
